import { createApi } from '@reduxjs/toolkit/query/react';
import  axiosInstance  from '../axiosinterceptor';
import { base_URL } from '../utils/api';

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
  async ({ url, method, data, params }) => {
    try {
      const result = await axiosInstance({
        url: url,
        method,
        data,
        params,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({ baseUrl: base_URL }),
  endpoints: (builder) => ({
    getData2: builder.query({
      query: () => {
        const hcplineIds = sessionStorage.getItem('last_hcp_line_id');
        const episodeHcpLineId = sessionStorage.getItem('episodeHcpLineId');
        const episodeDetails = JSON.parse(sessionStorage.getItem("episodeDetails"));
        const storedRole = sessionStorage.getItem("currentPage");

        const isLocked = episodeDetails.is_locked;
        const is_clicked = !isLocked;
        //  const hcp_line_id = episodeHcpLineId ? episodeHcpLineId:hcplineIds
         const hcp_line_id = hcplineIds
         const roleMap = {
         coderview: "coder",
         auditorPage: "auditor",
         episodeList: "coder"
       };

     const role = roleMap[storedRole] || "";
         
         console.log(role,"role")
        return {
          // url: `/getEpisodeDataAcs`,
          url:`/getEpisodeData`,
          method: 'GET',
          params: { hcp_line_id,is_clicked, role },
        };
      },

      transformResponse: (response) => {
        const sortAdditionalCodes = (list = []) => {
          return [...list].sort((a, b) => {
            const aZero = a.code?.startsWith("0");
            const bZero = b.code?.startsWith("0");

            if (aZero && !bZero) return 1;  
            if (!aZero && bZero) return -1;
            return 0;
          });
        };

        return {
          ...response,
          data: {
            ...response.data,
            additional_diagnoses: sortAdditionalCodes(
              response?.data?.additional_diagnoses ?? []
            )
          }
          
        };
      }
    }),
  })
});


export const {
  useLazyGetData2Query,
  useGetData2Query,
} = apiSlice;